module.exports = __webpack_public_path__ + "img/9.a8391289.svg";